import React from 'react';
import { useTranslation } from 'react-i18next';
import AutocompleteFilter, { FilterOption } from './AutocompleteFilter';

interface AccountProps {
    accounts: string[];
    value?: string[];
    onChange: (value: string[]) => void;
}

const Account: React.FC<AccountProps> = ({ accounts, value = [], onChange }) => {
    const { t } = useTranslation();
    const options: FilterOption[] = accounts.map((account) => ({
        id: account,
        label: account,
    }));

    return (
        <AutocompleteFilter
            options={options}
            value={value}
            onChange={onChange}
            label={t('transactions.filters.account.label')}
            placeholder={t('transactions.filters.account.placeholder')}
        />
    );
};

export default Account;
